import React from 'react'
import cn from 'classnames'
import { AudioLines, Film } from 'lucide-react'
import styles from './answer.module.scss'

// Compact provenance row for media an AI action consumed (image/video/audio inputs and
// references). Renders small thumbnails instead of full payload tiles; the geometry contract
// (fixed strip height, margins) is mirrored by BUCKETS_AI_INPUT_STRIP_HEIGHT in
// lib/answerPlaceholderHeight — change them together.
const thumbUrl = item => item?.thumbnailUrl || (item?.kind === 'image' ? item?.url : null)

export default function AiInputMediaStrip({ items, className }) {
    const visibleItems = (items || []).filter(Boolean)
    if (!visibleItems.length) return null

    return (
        <div
            className={cn(styles.aiInputMediaStripBase, className)}
            data-testid="ai-input-media-strip"
            onClick={ev => ev.stopPropagation()}
        >
            <span className={styles.aiInputMediaStripLabel}>Input</span>
            {visibleItems.map(item => {
                const imageUrl = thumbUrl(item)
                const label = item.modelLabel || item.label || 'AI input'
                const KindGlyph =
                    item.kind === 'video' ? Film : item.kind === 'audio' ? AudioLines : null
                const Thumb = item.onClick ? 'button' : 'div'
                return (
                    <Thumb
                        key={item.id || item.url}
                        {...(item.onClick ? { type: 'button', onClick: item.onClick } : {})}
                        className={cn(
                            styles.aiInputMediaThumb,
                            !item.onClick && styles.aiInputMediaThumbStatic,
                        )}
                        title={label}
                        aria-label={item.onClick ? label : undefined}
                    >
                        {imageUrl ? (
                            <img
                                className={styles.aiInputMediaThumbImage}
                                src={imageUrl}
                                alt={label}
                                loading="lazy"
                                decoding="async"
                            />
                        ) : (
                            <span className={styles.aiInputMediaThumbFallback}>
                                {KindGlyph ? <KindGlyph size={18} /> : null}
                            </span>
                        )}
                        {KindGlyph && imageUrl && (
                            <span className={styles.aiInputMediaThumbKind}>
                                <KindGlyph size={10} />
                            </span>
                        )}
                    </Thumb>
                )
            })}
        </div>
    )
}
